export default __webpack_public_path__ + "static/media/house.1c7697e1.svg";